// GENERATED FILE, PLEASE DO NOT EDIT
var ButtonGroupPaddingHorizontalLarge = 32;
var ButtonGroupPaddingHorizontalMedium = 24;
var ButtonGroupPaddingHorizontalSmall = 16;
var ButtonGroupPaddingVerticalLarge = 32;
var ButtonGroupPaddingVerticalMedium = 24;
var ButtonGroupPaddingVerticalSmall = 16;
var ButtonTabSpacingIconInlineLarge = 8;
var ButtonTabSpacingIconInlineMedium = 4;
var ButtonTabSpacingIconInlineSmall = 4;
var ButtonTabPaddingHorizontalLarge = 16;
var ButtonTabPaddingHorizontalMedium = 16;
var ButtonTabPaddingHorizontalSmall = 16;
var ButtonTabPaddingVerticalLarge = 0;
var ButtonTabPaddingVerticalMedium = 0;
var ButtonTabPaddingVerticalSmall = 0;
var ButtonToggleGroupPaddingHorizontalLarge = 16;
var ButtonToggleGroupPaddingHorizontalMedium = 12;
var ButtonToggleGroupPaddingHorizontalSmall = 12;
var ButtonSpacingPaddingHorizontalLarge = 32;
var ButtonSpacingPaddingHorizontalMedium = 24;
var ButtonSpacingPaddingHorizontalSmall = 16;
var ButtonSpacingItemMarginHorizontalLarge = 8;
var ButtonSpacingItemMarginHorizontalMedium = 4;
var ButtonSpacingItemMarginHorizontalSmall = 4;
var ModalActionButtonsInline = 8;
var NavBarPaddingHorizontalLarge = 32;
var NavBarPaddingHorizontalMedium = 24;
var NavBarPaddingHorizontalSmall = 16;
var NavBarPaddingVerticalLarge = 32;
var NavBarPaddingVerticalMedium = 24;
var NavBarPaddingVerticalSmall = 16;
var SmallPageMargin = 16;
var TagPaddingHorizontalLarge = 8;
var TagPaddingHorizontalMedium = 6;
var TagPaddingHorizontalSmall = 4;
var TagPaddingHorizontalXSmall = 4;
var TagPaddingVerticalLarge = 7;
var TagPaddingVerticalMedium = 3;
var TagPaddingVerticalSmall = 1;
var TagPaddingVerticalXSmall = 3;
var SpacingSemanticsAll = {
  ButtonGroupPaddingHorizontalLarge: ButtonGroupPaddingHorizontalLarge,
  ButtonGroupPaddingHorizontalMedium: ButtonGroupPaddingHorizontalMedium,
  ButtonGroupPaddingHorizontalSmall: ButtonGroupPaddingHorizontalSmall,
  ButtonGroupPaddingVerticalLarge: ButtonGroupPaddingVerticalLarge,
  ButtonGroupPaddingVerticalMedium: ButtonGroupPaddingVerticalMedium,
  ButtonGroupPaddingVerticalSmall: ButtonGroupPaddingVerticalSmall,
  ButtonSpacingItemMarginHorizontalLarge: ButtonSpacingItemMarginHorizontalLarge,
  ButtonSpacingItemMarginHorizontalMedium: ButtonSpacingItemMarginHorizontalMedium,
  ButtonSpacingItemMarginHorizontalSmall: ButtonSpacingItemMarginHorizontalSmall,
  ButtonSpacingPaddingHorizontalLarge: ButtonSpacingPaddingHorizontalLarge,
  ButtonSpacingPaddingHorizontalMedium: ButtonSpacingPaddingHorizontalMedium,
  ButtonSpacingPaddingHorizontalSmall: ButtonSpacingPaddingHorizontalSmall,
  ButtonTabPaddingHorizontalLarge: ButtonTabPaddingHorizontalLarge,
  ButtonTabPaddingHorizontalMedium: ButtonTabPaddingHorizontalMedium,
  ButtonTabPaddingHorizontalSmall: ButtonTabPaddingHorizontalSmall,
  ButtonTabPaddingVerticalLarge: ButtonTabPaddingVerticalLarge,
  ButtonTabPaddingVerticalMedium: ButtonTabPaddingVerticalMedium,
  ButtonTabPaddingVerticalSmall: ButtonTabPaddingVerticalSmall,
  ButtonTabSpacingIconInlineLarge: ButtonTabSpacingIconInlineLarge,
  ButtonTabSpacingIconInlineMedium: ButtonTabSpacingIconInlineMedium,
  ButtonTabSpacingIconInlineSmall: ButtonTabSpacingIconInlineSmall,
  ButtonToggleGroupPaddingHorizontalLarge: ButtonToggleGroupPaddingHorizontalLarge,
  ButtonToggleGroupPaddingHorizontalMedium: ButtonToggleGroupPaddingHorizontalMedium,
  ButtonToggleGroupPaddingHorizontalSmall: ButtonToggleGroupPaddingHorizontalSmall,
  ModalActionButtonsInline: ModalActionButtonsInline,
  NavBarPaddingHorizontalLarge: NavBarPaddingHorizontalLarge,
  NavBarPaddingHorizontalMedium: NavBarPaddingHorizontalMedium,
  NavBarPaddingHorizontalSmall: NavBarPaddingHorizontalSmall,
  NavBarPaddingVerticalLarge: NavBarPaddingVerticalLarge,
  NavBarPaddingVerticalMedium: NavBarPaddingVerticalMedium,
  NavBarPaddingVerticalSmall: NavBarPaddingVerticalSmall,
  SmallPageMargin: SmallPageMargin,
  TagPaddingHorizontalLarge: TagPaddingHorizontalLarge,
  TagPaddingHorizontalMedium: TagPaddingHorizontalMedium,
  TagPaddingHorizontalSmall: TagPaddingHorizontalSmall,
  TagPaddingHorizontalXSmall: TagPaddingHorizontalXSmall,
  TagPaddingVerticalLarge: TagPaddingVerticalLarge,
  TagPaddingVerticalMedium: TagPaddingVerticalMedium,
  TagPaddingVerticalSmall: TagPaddingVerticalSmall,
  TagPaddingVerticalXSmall: TagPaddingVerticalXSmall
};

export { ButtonGroupPaddingHorizontalLarge, ButtonGroupPaddingHorizontalMedium, ButtonGroupPaddingHorizontalSmall, ButtonGroupPaddingVerticalLarge, ButtonGroupPaddingVerticalMedium, ButtonGroupPaddingVerticalSmall, ButtonSpacingItemMarginHorizontalLarge, ButtonSpacingItemMarginHorizontalMedium, ButtonSpacingItemMarginHorizontalSmall, ButtonSpacingPaddingHorizontalLarge, ButtonSpacingPaddingHorizontalMedium, ButtonSpacingPaddingHorizontalSmall, ButtonTabPaddingHorizontalLarge, ButtonTabPaddingHorizontalMedium, ButtonTabPaddingHorizontalSmall, ButtonTabPaddingVerticalLarge, ButtonTabPaddingVerticalMedium, ButtonTabPaddingVerticalSmall, ButtonTabSpacingIconInlineLarge, ButtonTabSpacingIconInlineMedium, ButtonTabSpacingIconInlineSmall, ButtonToggleGroupPaddingHorizontalLarge, ButtonToggleGroupPaddingHorizontalMedium, ButtonToggleGroupPaddingHorizontalSmall, ModalActionButtonsInline, NavBarPaddingHorizontalLarge, NavBarPaddingHorizontalMedium, NavBarPaddingHorizontalSmall, NavBarPaddingVerticalLarge, NavBarPaddingVerticalMedium, NavBarPaddingVerticalSmall, SmallPageMargin, SpacingSemanticsAll, TagPaddingHorizontalLarge, TagPaddingHorizontalMedium, TagPaddingHorizontalSmall, TagPaddingHorizontalXSmall, TagPaddingVerticalLarge, TagPaddingVerticalMedium, TagPaddingVerticalSmall, TagPaddingVerticalXSmall, SpacingSemanticsAll as default };
